export const SITE_URL = "https://hittapodd.se";

/** Absolute canonical URL for a site path. Page 1 and non-paginated pages never carry a query string. */
export const canonicalUrl = (path: string, page = 1): string => `${SITE_URL}${path}${page > 1 ? `?page=${page}` : ""}`;

const MIN_SNIPPET = 50;
const MIN_CONTENT = 200;

const length = (text?: string | null): number => Array.from((text ?? "").trim()).length;

/**
 * An episode with almost no text of its own (snippet under 50 characters and show notes under 200) is
 * kept out of search results and the sitemap. Measured on the stored text, like the server does.
 * Keep in step with EpisodeEligibility in yetric.se.
 */
export const isThinEpisode = (episode: { snippet?: string | null; content?: string | null }): boolean =>
    length(episode.snippet) < MIN_SNIPPET && length(episode.content) < MIN_CONTENT;
